export const StateConts={
CARTLENGTHUPDATE:"CARTLENGTHUPDATE",
CARTUPDATE:"CARTUPDATE",
USERDETAILSUPADTE:"USERDETAILSUPADTE"
}